import React from 'react'
import { IconToggle } from 'react-mdl'

export const hasMark = state => state.marks.some(mark => mark.type === 'italic')

export const markStrategy = state =>
  state.transform().toggleMark('italic').focus().apply()

const Node = ({ children }) => (
  <i>
    {children}
  </i>
)

const Schema = {
  marks: {
    italic: Node,
  },
}

const KeyboardShortcut = (event, data, state) => {
  if (data.isMod && data.key === 'i') return markStrategy(state)
  return
}

const Button = ({ state, onChange }) => (
  <IconToggle
    name="format_italic"
    onChange={() => onChange(markStrategy(state))}
    checked={hasMark(state)}
  />
)

const Plugin = () => ({
  schema: Schema,

  onKeyDown(...args) {
    return KeyboardShortcut(...args)
  },
})

export { Button as ItalicButton, Plugin as ItalicPlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Italic.js